import { z } from 'zod';
/** ObjectId в строковом виде. Границы системы парсим, а не приводим. */
export const objectIdSchema = z
    .string()
    .regex(/^[a-f\d]{24}$/i, 'Expected a 24-character hexadecimal id');
export const paginationSchema = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(50),
    cursor: z.string().optional(),
});
export const localeSchema = z.enum(['en', 'ru', 'es']);
/**
 * CLAUDE.md, правило 5: время клиента и сервера пишутся ОБА, расхождение помечается.
 * Клиентские часы переводятся за пять секунд — доверять им нельзя,
 * но и выбрасывать нельзя: расхождение само по себе сигнал.
 */
export const dualTimestampSchema = z.object({
    clientAt: z.coerce.date(),
    serverAt: z.coerce.date(),
    skewMs: z.number().int(),
});
export const errorResponseSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
//# sourceMappingURL=common.js.map